export function parsePlannerDeepLink(search) {
  const params = new URLSearchParams(search || '');
  const processId = (params.get('processId') || '').trim();
  const workTicket = (params.get('workTicket') || '').trim();

  if (!processId && !workTicket) {
    return null;
  }

  return { processId, workTicket };
}
